import axiosInstance from './axiosInstance'
import { ApiResponse, PagedResponse, Referral, ReferralApplication } from '../types'

export const referralApi = {
  apply: (jobId: number, coverLetter?: string) =>
    axiosInstance.post<ApiResponse<ReferralApplication & { resumeUploadUrl?: string }>>(
      `/referrals/apply/${jobId}`, { coverLetter }
    ),

  getApplicationsForJob: (jobId: number, page = 0, size = 20) =>
    axiosInstance.get<ApiResponse<PagedResponse<ReferralApplication>>>(
      `/referrals/applications/${jobId}?page=${page}&size=${size}`
    ),

  refer: (applicationId: number) =>
    axiosInstance.post<ApiResponse<Referral>>(`/referrals/refer/${applicationId}`),

  getMyApplications: (page = 0, size = 20) =>
    axiosInstance.get<ApiResponse<PagedResponse<ReferralApplication>>>(
      `/referrals/my-applications?page=${page}&size=${size}`
    ),

  getMyReferrals: (page = 0, size = 20) =>
    axiosInstance.get<ApiResponse<PagedResponse<Referral>>>(
      `/referrals/my-referrals?page=${page}&size=${size}`
    ),

  getByReferralId: (referralId: string) =>
    axiosInstance.get<ApiResponse<Referral>>(`/referrals/${referralId}`),

  getResumePresignUrl: (applicationId: number) =>
    axiosInstance.post<ApiResponse<{ uploadUrl: string; s3Key: string }>>(
      `/referrals/${applicationId}/resume/presign`
    ),
}
